export const GET_USER_CUSTOM_ATTENDANCE_SCHEDULE = 'GET_USER_CUSTOM_ATTENDANCE_SCHEDULE'
export const GET_ONE_USER_CUSTOM_ATTENDANCE_SCHEDULE = 'GET_ONE_USER_CUSTOM_ATTENDANCE_SCHEDULE'
export const ADD_USER_CUSTOM_ATTENDANCE_SCHEDULE = 'ADD_USER_CUSTOM_ATTENDANCE_SCHEDULE'
export const UPDATE_USER_CUSTOM_ATTENDANCE_SCHEDULE = 'UPDATE_USER_CUSTOM_ATTENDANCE_SCHEDULE'
export const DELETE_USER_CUSTOM_ATTENDANCE_SCHEDULE = 'DELETE_USER_CUSTOM_ATTENDANCE_SCHEDULE'
export const DELETE_ALL_USER_CUSTOM_ATTENDANCE_SCHEDULE =
  'DELETE_ALL_USER_CUSTOM_ATTENDANCE_SCHEDULE'
export const BULK_ADD = 'BULK_ADD'
